var _desc, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPackagesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "packages-icon_svg__packages-icon_svg__Canvas",
    transform: "translate(14161 7302)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "packages-icon_svg__packages-icon_svg__Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "packages-icon_svg__packages-icon_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#packages-icon_svg__packages-icon_svg__path0_fill",
    transform: "translate(-14161 -7302)",
    fill: "#FFFFFF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "packages-icon_svg__packages-icon_svg__path0_fill",
    fillRule: "evenodd",
    d: "M -2.08353e-22 4.03357L -2.08353e-22 16.7499L 9.94413 20.7841L 19.8883 16.7499L 19.8883 4.03357L 9.94413 0L -2.08353e-22 4.03357ZM 16.6898 4.79769L 9.94413 7.5342L 3.19844 4.79769L 9.94413 2.06117L 16.6898 4.79769ZM 1.87702 6.32337L 9.00562 9.21507L 9.00562 18.3417L 1.87702 15.4497L 1.87702 6.32337ZM 10.8826 18.3414L 10.8826 9.21507L 18.0112 6.32368L 18.0112 15.4497L 10.8826 18.3414Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackagesIcon);
export default __webpack_public_path__ + "static/media/packages-icon.7b82493f6603fcd134356c8f30e23bfb.svg";
export { ForwardRef as ReactComponent };